"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { usePathname } from "next/navigation";
import { useEffect, useLayoutEffect } from "react";
import { useTopLevelFilterStore } from "@/lib/stores/top-level-filter-store";
function handleTopLevelFilterPopstate() {
  const rehydrateResult = useTopLevelFilterStore.persist.rehydrate();
  void Promise.resolve(rehydrateResult).then(() => {
    useTopLevelFilterStore.getState().switchPath(window.location.pathname, {
      force: true
    });
  });
}

/**
 * Single app-level boundary for pathname-scoped top-level filters.
 * Mount once inside the protected shell — not per chart/card hook.
 */
export function TopLevelFilterScope(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const hasHydrated = useTopLevelFilterStore(_temp);
  const switchPath = useTopLevelFilterStore(_temp2);
  const setHasHydrated = useTopLevelFilterStore(_temp3);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp5, t1);
  let t2;
  let t3;
  if ($[1] !== setHasHydrated || $[2] !== switchPath) {
    t2 = () => {
      if (useTopLevelFilterStore.persist.hasHydrated()) {
        setHasHydrated(true);
        switchPath(window.location.pathname, {
          force: true
        });
        return;
      }
      return useTopLevelFilterStore.persist.onFinishHydration(() => {
        setHasHydrated(true);
        switchPath(window.location.pathname, {
          force: true
        });
      });
    };
    t3 = [setHasHydrated, switchPath];
    $[1] = setHasHydrated;
    $[2] = switchPath;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[5] !== hasHydrated || $[6] !== pathname || $[7] !== switchPath) {
    t4 = () => {
      if (!hasHydrated) {
        return;
      }
      switchPath(pathname);
    };
    t5 = [hasHydrated, pathname, switchPath];
    $[5] = hasHydrated;
    $[6] = pathname;
    $[7] = switchPath;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useLayoutEffect(t4, t5);
  return children;
}
function _temp5() {
  window.addEventListener("popstate", handleTopLevelFilterPopstate);
  return _temp4;
}
function _temp4() {
  window.removeEventListener("popstate", handleTopLevelFilterPopstate);
}
function _temp3(state_1) {
  return state_1.setHasHydrated;
}
function _temp2(state_0) {
  return state_0.switchPath;
}
function _temp(state) {
  return state._hasHydrated;
}